import { Blob } from './blob-types';

export enum ExhibitLabelFormat {
  ALPHABETIC = 'ALPHABETIC',
  NUMERIC = 'NUMERIC',
}

export interface BaseAgentChatWorkspace {
  name: string;
  disable_exhibit_pages: boolean;
  exhibit_label_format: ExhibitLabelFormat;
}

export enum AgentChatWorkspaceExhibitGenerationStatus {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  GENERATING = 'GENERATING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface AgentChatWorkspace extends BaseAgentChatWorkspace {
  id: string;
  created_at: string;
  modified_at: string;
  document_id: string;
  matter_id: string;
  exhibit_pdf_download_url: string | null;
  exhibit_pdf_generation_status: AgentChatWorkspaceExhibitGenerationStatus;
  exhibit_pdf_generation_error: string;
}

export interface AgentChatWorkspaceExhibit {
  id: string;
  name: string;
  blob: string;
  blob_details: Blob;
  workspace: string;
  order: number;
  modified_at: string;
  created_at: string;
}

export interface CreateAgentChatWorkspaceExhibit {
  name: string;
  blob_id: string;
  index?: number | null;
}

export interface UpdateAgentChatWorkspaceExhibit {
  name: string;
  index?: number | null;
}
